<ng-container *ngIf="item">
  <ng-container [ngSwitch]="item.type">
    <ng-container *ngSwitchCase="NOTIFICATION_TYPE.CriticalInfoUpdated">
      <div class="notification" [ngClass]="{ new: !item.isViewed }">
        <div class="notification__icon">
          <app-icon-feather
            icon="alert-triangle"
            fill="inherit"
            stroke="inherit"
            width="18"
            height="18"
          ></app-icon-feather>
        </div>
        <div class="notification__info" *ngIf="item.payload as payload">
          <!-- Chip colors follow the card convention: green = yes answer,
               red = no answer, amber = in between ("agent decides", "not
               sure"). The words always carry the meaning. -->
          <ng-container *ngIf="payload?.changedFrom === null">
            <span class="text--md"
              >{{ payload?.propertyNameLabel }} has been set -
            </span>
            <span
              class="crit-info text--accent"
              [ngClass]="'crit-info--' + (payload?.changedToPolarity || 'other')"
            >
              {{ payload?.changedToLabel }}
            </span>
          </ng-container>

          <ng-container *ngIf="payload?.changedFrom !== null">
            <p class="text--md">
              {{ payload?.propertyNameLabel }} has been changed
            </p>
            <p class="mt-2">
              <span>from </span>
              <span
                class="crit-info"
                [ngClass]="'crit-info--' + (payload?.changedFromPolarity || 'other')"
                >{{ payload?.changedFromLabel }}</span
              >
              <span> to </span>
              <span
                class="crit-info text--accent"
                [ngClass]="'crit-info--' + (payload?.changedToPolarity || 'other')"
                >{{ payload?.changedToLabel }}</span
              >
            </p>
          </ng-container>

          <ng-container *ngIf="item.changedBy as changedBy">
            <p class="c--dark-gray mt-2">
              {{
                (
                  (changedBy.firstName || "") +
                  " " +
                  (changedBy.lastName || "")
                ).trim() || changedBy.email
              }}
            </p>
          </ng-container>
        </div>
        <div class="notification__date text--sm c--dark-gray">
          {{ item.createdAt | date : " h:mma M/d/yy" }}
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="NOTIFICATION_TYPE.InvitationStatusUpdated">
      <div class="notification" [ngClass]="{ new: !item.isViewed }">
        <div class="notification__icon">
          <app-icon-feather
            icon="alert-triangle"
            fill="inherit"
            stroke="inherit"
            width="18"
            height="18"
          ></app-icon-feather>
        </div>
        <div class="notification__info" *ngIf="item.payload as payload">
          <ng-container
            *ngIf="payload?.newStatus === INVITATION_STATUS.pending"
          >
            <span class="text--md"
              >The invitation is sent to
              {{
                (
                  (payload?.receiver?.firstName || "") +
                  " " +
                  (payload?.receiver?.lastName || "")
                ).trim() || payload?.receiver?.email
              }}
            </span>
          </ng-container>

          <ng-container
            *ngIf="payload?.newStatus === INVITATION_STATUS.canceled"
          >
            <span class="text--md"
              >The invitation for
              {{
                (
                  (payload?.receiver?.firstName || "") +
                  " " +
                  (payload?.receiver?.lastName || "")
                ).trim() || payload?.receiver?.email
              }}
              was cancelled
            </span>
          </ng-container>

          <ng-container
            *ngIf="payload?.newStatus === INVITATION_STATUS.accepted"
          >
            <span class="text--md"
              >{{
                userRole === USER_ROLE.patient
                  ? "The invitation was accepted by " +
                      (
                        (payload?.receiver?.firstName || "") +
                        " " +
                        (payload?.receiver?.lastName || "")
                      ).trim() || payload?.receiver?.email
                  : "The invitation from " +
                    ((
                      (item?.patient?.firstName || "") +
                      " " +
                      (item?.patient?.lastName || "")
                    ).trim() || item?.patient?.email) +
                    " was accepted."
              }}
            </span>
          </ng-container>

          <ng-container
            *ngIf="payload?.newStatus === INVITATION_STATUS.declined"
          >
            <span class="text--md"
              >{{
                userRole === USER_ROLE.patient
                  ? "The invitation was declined by " +
                      (
                        (payload?.receiver?.firstName || "") +
                        " " +
                        (payload?.receiver?.lastName || "")
                      ).trim() || payload?.receiver?.email
                  : "The invitation from " +
                    ((
                      (item?.patient?.firstName || "") +
                      " " +
                      (item?.patient?.lastName || "")
                    ).trim() || item?.patient?.email) +
                    " was declined."
              }}
            </span>
          </ng-container>

          <ng-container *ngIf="item.changedBy as changedBy">
            <p class="c--dark-gray mt-2">
              {{
                (
                  (changedBy.firstName || "") +
                  " " +
                  (changedBy.lastName || "")
                ).trim() || changedBy.email
              }}
            </p>
          </ng-container>
        </div>
        <div class="notification__date text--sm c--dark-gray">
          {{ item.createdAt | date : " h:mma M/d/yy" }}
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="NOTIFICATION_TYPE.PatientQrCodeScanned">
      <div
        class="notification d-flex align-items-center"
        [ngClass]="{ new: !item.isViewed }"
        *ngIf="item.payload as payload"
      >
        <div class="notification__icon">
          <app-icon-feather
            icon="book-open"
            fill="inherit"
            stroke="inherit"
            width="18"
            height="18"
          ></app-icon-feather>
        </div>
        <div class="notification__info" *ngIf="item.payload as payload">
          <span class="text--md"
            >The critical information was accessed via QR Code/Web Link.</span
          >
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="NOTIFICATION_TYPE.GeneralInfoUpdated">
      <ng-container *ngTemplateOutlet="formUpdate"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="NOTIFICATION_TYPE.LivingWillUpdated">
      <ng-container *ngTemplateOutlet="formUpdate"></ng-container>
    </ng-container>
  </ng-container>

  <ng-template #formUpdate>
    <div class="notification" [ngClass]="{ new: !item.isViewed }">
      <div class="notification__icon">
        <app-icon-feather
          icon="edit-2"
          fill="inherit"
          stroke="inherit"
          width="18"
          height="18"
        ></app-icon-feather>
      </div>
      <div class="notification__info" *ngIf="item.payload as payload">
        <!--
          One save = one notification, listing everything it changed. Editing
          an address used to arrive as twelve separate notifications.
        -->
        <ng-container *ngIf="payload?.changes?.length; else singleChange">
          <p class="text--md">
            {{ formUpdateHeadline(payload) }}
          </p>
          <ul style="margin: 4px 0 0 18px">
            <li *ngFor="let change of payload.changes">
              <span>{{ fieldLabel(change.propertyName) }}</span>
              <ng-container *ngIf="change.changedFrom">
                <span> from </span>
                <span class="text--underline">{{ change.changedFrom }}</span>
              </ng-container>
              <span> to </span>
              <span class="text--underline text--accent">{{ change.changedTo }}</span>
            </li>
          </ul>
        </ng-container>

        <ng-template #singleChange>
          <ng-container *ngIf="payload?.changedFrom === null">
            <span class="text--md"
              >{{ payload?.propertyNameLabel }} has been added -
            </span>
            <span class="text--accent text--underline">{{
              payload?.changedTo
            }}</span>
          </ng-container>

          <ng-container
            *ngIf="
              payload?.changedTo === null ||
              payload?.changedTo === '' ||
              payload?.changedTo?.length === 0
            "
          >
            <span class="text--md"
              >{{ payload?.propertyNameLabel }} has been deleted.</span
            >
          </ng-container>

          <ng-container
            *ngIf="payload?.changedFrom !== null && !!payload?.changedTo"
          >
            <p class="text--md">
              {{ payload?.propertyNameLabel }} has been changed
            </p>
            <p>
              <span>from </span>
              <span class="text--underline">{{ payload?.changedFrom }}</span>
              <span> to </span>
              <span class="text--underline text--accent">{{
                payload?.changedTo
              }}</span>
            </p>
          </ng-container>
        </ng-template>

        <ng-container *ngIf="item.changedBy as changedBy">
          <p class="c--dark-gray mt-2">
            {{
              (
                (changedBy.firstName || "") +
                " " +
                (changedBy.lastName || "")
              ).trim() || changedBy.email
            }}
          </p>
        </ng-container>
      </div>
      <div class="notification__date text--sm c--dark-gray flex-shrink-0 pl-5">
        {{ item.createdAt | date : " h:mma M/d/yy" }}
      </div>
    </div>
  </ng-template>
</ng-container>
